import { useState, useEffect, useCallback } from 'react';
import { transporterAPI } from '@/services/api';

export const useVehicleTypes = () => {
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchVehicleTypes = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await transporterAPI.getVehicleTypes();
      setVehicleTypes(response.data);
    } catch (err) {
      console.error('Erreur lors du chargement des types de véhicules:', err);
      setError(err.response?.data?.detail || 'Erreur lors du chargement des types de véhicules');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVehicleTypes();
  }, [fetchVehicleTypes]);

  return {
    vehicleTypes,
    loading,
    error,
    refetch: fetchVehicleTypes,
  };
};



